export interface RHQuestionNumberSource {
    questionNumber?: number
}

export class RHQuestionNumberFormatter {

    static metadataTextForQuestion(question: RHQuestionNumberSource): string {
        if (typeof question.questionNumber != "number" || !Number.isFinite(question.questionNumber)) {
            return "Küsimus"
        }

        return `Küsimus nr ${question.questionNumber}`
    }

}
